module.exports = "/_next/static/images/eject-0defd88f0ddc21525955aeb1fbc9eca7.svg";